import React from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import FailedWrapper from "./Failed.style";
import icon_error from "../../../../assets/images/icons/icon_error.svg";
import worldcup from "../../../../assets/images/worldcup_orange.svg";
import { useEffect } from "react";
import * as globalUtils from "../../../../helpers/utils";
import { useLocation } from "react-router-dom";

const Failed = (props) => {
    const { t, i18n } = useTranslation();
    const { isWorldcup } = useSelector((state) => state.travel);
    const location = useLocation();

    useEffect(() => {
        // window.lmSMTObj.page(location.pathname, {
        //     path: location.pathname,
        //     language: globalUtils.isArabic(i18n.language) ? "Arabic" : "English",
        //     referrer: document.referrer,
        //     title: document.title,
        //     url: document.URL,
        //     search: "",
        // });
        let productName = localStorage.getItem("productName");
        let subProductName = localStorage.getItem("subProductName");
        // window.lmSMTObj.track("purchaseCompleted", {
        //     "paymentSuccessful": "false",
        //     "productName": productName,
        //     "subProductName": subProductName
        // })
        // for Google tagging (Payment failed)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "error_displayed",
            error_location: "Travel Insurance New",
            funnel_step: "step_8",
            error_messages: "Payment Failed",
        });
    }, []);

    return (
        <FailedWrapper>
            <div className="payment-details-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className={`${isWorldcup ? "worldcup_success_wrapper" : ""}`}>
                                {isWorldcup && (
                                    <div className="worldcup_banner">
                                        <img src={worldcup} />
                                        <div>
                                            <h5>{t("worldcup.worldcup")}</h5>
                                            <p>{t("worldcup.date")}</p>
                                        </div>
                                    </div>
                                )}
                                <div className="header-wrapper pt-5">
                                    <div className="image">
                                        <img src={icon_error} alt="" />
                                    </div>
                                    <div className="text">
                                        <h2> {props.i18n.t("Thank_you")}</h2>
                                        <p className="smaller">
                                            {props.i18n.t("error_occured")}
                                            <br />
                                            {/* <p className="smaller">For more information please contact us on</p> */}
                                            {/* <a href="mailto:SMEeSupport@tawuniya.com.sa">SMEeSupport@tawuniya.com.sa</a> */}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FailedWrapper>
    );
};

export default withTranslation()(Failed);
